export default __webpack_public_path__ + "static/media/signup-tablet.897edb29.mp4";